import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import TableTopicsData from "../../../Pages/IndividualUnit/TableTopicsData";
import TopicDetailsModal from "./TopicsDetailModal";
import WeekSelector from "./WeekSelector";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";

import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';

const TopicDiscussedTab = ({ fullURL, payload, resetTrigger, summarystudent, isApiLoading }) => {
  const [selectedWeeks, setSelectedWeek] = useState(null);
  const [tableDisplayData, setTableDisplayData] = useState([]); // This will hold data for the table
  const [fullTopicData, setFullTopicData] = useState({}); // This will hold the raw data from API, including Q&A
  const [weeks, setWeeks] = useState({});
  const [activeSubtab, setActiveSubtab] = useState('Topics Covered');
  const [loading, setloading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [weekPeriod, setweekPeriod] = useState(null);
  const [tableissuesDisplayData, settableissuesDisplayData] = useState([]); // This will hold data for the table
  const user_token = localStorage.getItem('usertoken');

  const toggleSubTab = (tab) => {
    setActiveSubtab(tab);
  };
  useEffect(() => {
    // Reset weeks state when resetTrigger changes
    setOpenModal(false);
    setWeeks({});
    setSelectedWeek(null);
    setweekPeriod(null);
    setTableDisplayData([]);
    settableissuesDisplayData([]);
    setloading(false);
  }, [resetTrigger]);

 
const fetchTableData = async () => {
    setweekPeriod(null);
    setloading(true);
    if (!payload || Object.keys(payload).length === 0) return;

    let config = {
        headers: {
            Authorization: `Token ${user_token}`,
        },
    };

    try {
        const tableres = await axios.post(fullURL, {
            ...payload,
            mode: 'insights',
            week: selectedWeeks.label,
        }, config);

        console.warn({ tableres });

        // ✅ Updated: tableres.data.issues (axios wraps response in .data)
        settableissuesDisplayData(tableres?.issues || {});

        if (tableres) {
            setFullTopicData(tableres?.topics || {});
            setweekPeriod(tableres?.week || null);

            const transformedData = Object.keys(tableres?.topics || {}).map(
                (topicName, index) => {
                    const questions = tableres.topics[topicName].clusters;
                    const questionsCount = questions.length;

                    return {
                        id: index + 1,
                        topicName: topicName,
                        Noofstudentsasked: tableres.topics[topicName].total_students,
                        Noofquestionsasked: questionsCount,
                    };
                }
            );

            const sortedData = transformedData.sort(
                (a, b) => b.Noofstudentsasked - a.Noofstudentsasked
            );

            setTableDisplayData(sortedData);
        }
    } catch (error) {
        console.error('Error fetching table data:', error);
        setTableDisplayData([]);
        setFullTopicData({});
        settableissuesDisplayData({});
    } finally {
        setloading(false);
    }
};

  useEffect(() => {
    if (!selectedWeeks) {
      setTableDisplayData([]);
      setweekPeriod(null);
      settableissuesDisplayData([]);

    }
  }, [selectedWeeks]);

  useEffect(() => {
    setWeeks({});
  }, [fullURL]);

  useEffect(() => {
    console.warn('selectedWeeks', selectedWeeks);
    if (selectedWeeks) {
      fetchTableData();
    }
  }, [selectedWeeks, payload]);

  useEffect(() => {
    console.warn('payload', payload);
    if (!payload || Object.keys(payload).length === 0) return;
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    const fetchWeeks = async () => {
      try {
        const weekres = await axios.post(fullURL, {
          ...payload,
          mode: 'insights',
        }, config);
        if (weekres && weekres && weekres.weeks) {
          setWeeks(weekres.weeks);
        }
      } catch (error) {
        console.error('Error fetching weeks:', error);
      }
    };

    fetchWeeks();
  }, [fullURL, payload]);

  const handleTopicClick = (topicName) => {
    const topicDetails = fullTopicData[topicName];
    setModalContent(topicDetails);
    setModalTitle(topicName);
    setOpenModal(true);
    // }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent([]);
    setModalTitle('');
  };

  return (
    <div style={{ minHeight: '200px' }}>
      <div className="d-flex align-items-center">
        <div>
          {weekPeriod && (
            <p className="mb-2">
              Week Period :
              <strong className="ml-1" style={{ marginLeft: '5px' }}>
                {weekPeriod ? weekPeriod : 'N/A'}
              </strong>
            </p>
          )}
        </div>
        <div className="ms-auto">
          <WeekSelector
            weeks={weeks}
            selectedWeeks={selectedWeeks}
            setSelectedWeek={setSelectedWeek}
          />
        </div>
      </div>


      {isApiLoading ? ( // Show spinner only when API is loading
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          <Spinner style={{ width: '3rem', height: '3rem' }} />
        </div>
      ) : (
        // Data loaded state
        <>
          {/* Conditional rendering for TableTopicsData based on tableDisplayData */}
          {selectedWeeks ? (
            <>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={
                      activeSubtab === 'Topics Covered' ? 'active' : ''
                    }
                    active={activeSubtab === 'Topics Covered'}
                    onClick={() => toggleSubTab('Topics Covered')}
                    style={{
                      cursor: 'pointer',
                      marginRight: '3px',
                    }}
                  >
                    Topics Covered
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      activeSubtab === 'Student Issues' ? 'active' : ''
                    }
                    active={activeSubtab === 'Student Issues'}
                    onClick={() => toggleSubTab('Student Issues')}
                    style={{
                      cursor: 'pointer',
                      marginRight: '3px',
                    }}
                  >
                    Student Issues
                  </NavLink>
                </NavItem>
              </Nav>

              {activeSubtab === 'Topics Covered' && (
                <>
                  <TableTopicsData
                    noRowsLabel={'No Call Insights Available for this Week'}
                    topicsData={tableDisplayData}
                    onTopicClick={handleTopicClick}
                    columns={[
                      {
                        field: 'sno',
                        headerName: 'S.No',

                        width: 80,
                        headerAlign: 'left',
                        align: 'center',
                        sortable: false,
                        // Just show sno value, no renderCell needed
                      },
                      {
                        field: 'topicName',
                        headerName: 'Topics',
                        flex: 1,
                        minWidth: 200,
                      },
                      {
                        field: 'Noofstudentsasked',
                        headerName: 'No of Students Asked',
                        width: 230,
                        headerAlign: 'left',
                        align: 'center',
                      },
                      {
                        field: 'Noofquestionsasked',
                        headerName: 'No of Questions Asked',
                        width: 230,
                        headerAlign: 'left',
                        align: 'center',
                      },
                    ]}
                  />
                </>
              )}
             {/* {activeSubtab === 'Student Issues' && (
                <div className="row mt-2">
                  <div className="col-md-12 ">
                    {
                      Object.keys(tableissuesDisplayData || {}).length > 0 ?
                    Object.keys(tableissuesDisplayData).map((topic, index) => (
                      <div key={index} className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light">
                        <h6 className="fw-bold  mb-2">{topic}</h6>
                        <ul className="list-group-item-info ps-3">
                          {tableissuesDisplayData[topic].map((issue, issueIndex) => (
                            <li key={issueIndex} className="mb-1 text-dark">
                              <i className="bi bi-dot me-2 text-secondary"></i>{issue}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )): <p className="ms-3">No Student Issues Available</p>}
                  </div>
                </div>
              )} */}
              {activeSubtab === 'Student Issues' && (
    <div className="row mt-2">
        <div className="col-md-12">
            {tableissuesDisplayData && Object.keys(tableissuesDisplayData).length > 0 ? (
                Object.keys(tableissuesDisplayData).map((category, categoryIndex) => {
                    const categoryData = tableissuesDisplayData[category];
                    const formatTitle = (str) =>
                        str.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

                    return (
                        <div key={categoryIndex} className="mb-3">
                            {/* Category Title */}
                            <h4 className="fw-bold mb-2">{formatTitle(category)}</h4>

                            {/* Topics inside this category */}
                            {Object.keys(categoryData).map((topic, topicIndex) => (
                                <div
                                    key={topicIndex}
                                    className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light"
                                >
                                    {/* Topic Title */}
                                    <h6 className="fw-bold mb-2">{topic}</h6>

                                    {/* Issues list */}
                                    <ul className="ps-3">
                                        {categoryData[topic].map((issue, issueIndex) => (
                                            <li key={issueIndex} className="mb-1 text-dark">
                                                {issue}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    );
                })
            ) : (
                <p className="ms-3">No Student Issues Available</p>
            )}
        </div>
    </div>
                )}
            </>
          ) : (
            <div class="col-12">
              <p class="text-muted w-100 mt-3 text-center">
                <>Please Select the week to view Call Insights</>
              </p>
            </div>
          )}

          {/* TopicDetailsModal always rendered but its 'open' prop controls visibility */}
          <TopicDetailsModal
            open={openModal}
            onClose={handleCloseModal}
            title={modalTitle}
            contentDetails={modalContent.clusters}
          />
        </>
      )}
    </div>
  );
};

export default TopicDiscussedTab;
